import { risapi, getAxiosConfig } from './risapi';

/**
 * Submits the data for a single delivery to the backend.
 * @param {number} gameId The ID of the game being scored.
 * @param {object} deliveryData The data for the ball (batsman, bowler, runs, etc.).
 * @param {function} callback The callback function to handle the response.
 */
export const scoreDelivery = async (gameId, deliveryData, callback) => {
    try {
        const response = await risapi.post(`/api/games/${gameId}/score-delivery`, deliveryData, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const updateDelivery = async (deliveryData, callback) => {
    try {
        // We use PUT for updating a specific resource, as defined in our API route.
        const response = await risapi.put(`/api/deliveries/${deliveryData.id}`, deliveryData, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};
